'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';

type Mode = 'login' | 'register';

export default function LoginPage() {
  const router = useRouter();
  const [mode, setMode] = useState<Mode>('login');
  const [username, setUsername] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setError('');
    setLoading(true);
    const endpoint = mode === 'login' ? '/api/auth/login' : '/api/auth/register';
    const body = mode === 'login' ? { username, password } : { username, name, password };

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const json = await res.json();
      if (!res.ok) { setError(json.error); return; }
      window.location.replace('/');
    } catch {
      setError('네트워크 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') submit();
  };

  return (
    <main className="min-h-screen bg-amber-50 flex flex-col items-center justify-center px-4">
      <div className="text-6xl mb-4">🗝️</div>
      <h1 className="text-3xl font-black text-amber-800 mb-1">열려라 참깨</h1>
      <p className="text-amber-600 font-bold mb-8">Open Sesame</p>

      <div className="bg-white rounded-3xl shadow-xl p-8 w-full max-w-sm">
        {/* 탭 */}
        <div className="flex rounded-2xl bg-amber-50 p-1 mb-6">
          {(['login', 'register'] as Mode[]).map((m) => (
            <button
              key={m}
              onClick={() => { setMode(m); setError(''); }}
              className={`flex-1 py-2 rounded-xl font-black text-sm transition-colors cursor-pointer
                ${mode === m ? 'bg-amber-500 text-white shadow' : 'text-amber-600 hover:text-amber-800'}`}
            >
              {m === 'login' ? '로그인' : '회원가입'}
            </button>
          ))}
        </div>

        <div className="space-y-3">
          <div>
            <label className="text-sm font-bold text-gray-600 mb-1 block">아이디</label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={handleKey}
              placeholder="아이디를 입력하세요"
              className="w-full border-2 border-gray-200 rounded-2xl px-4 py-3 text-base focus:outline-none focus:border-amber-400 transition-colors"
            />
          </div>

          {mode === 'register' && (
            <div>
              <label className="text-sm font-bold text-gray-600 mb-1 block">이름 (닉네임)</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={handleKey}
                placeholder="예: 민준이"
                className="w-full border-2 border-gray-200 rounded-2xl px-4 py-3 text-base focus:outline-none focus:border-amber-400 transition-colors"
              />
            </div>
          )}

          <div>
            <label className="text-sm font-bold text-gray-600 mb-1 block">비밀번호</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKey}
              placeholder="비밀번호를 입력하세요"
              className="w-full border-2 border-gray-200 rounded-2xl px-4 py-3 text-base focus:outline-none focus:border-amber-400 transition-colors"
            />
          </div>

          {error && (
            <p className="text-red-500 text-sm font-bold text-center">{error}</p>
          )}

          <button
            onClick={submit}
            disabled={loading}
            className="w-full bg-amber-500 hover:bg-amber-600 text-white font-black py-3 rounded-2xl text-lg shadow transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed mt-2"
          >
            {loading ? '처리 중...' : mode === 'login' ? '로그인 🗝️' : '가입하기 ✨'}
          </button>
        </div>
      </div>
    </main>
  );
}
